import React, { createContext, useContext, useEffect, useState } from 'react';
import { subscription as subscriptionApi } from '../api';
import { useAuth } from './AuthContext';

const SubscriptionContext = createContext({});

export function SubscriptionProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [plan, setPlan] = useState('free');
  const [planStatus, setPlanStatus] = useState('active');
  const [planExpiresAt, setPlanExpiresAt] = useState(null);
  const [invoicesThisMonth, setInvoicesThisMonth] = useState(0);
  const [invoiceLimit, setInvoiceLimit] = useState(5);
  const [canCreateInvoice, setCanCreateInvoice] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await subscriptionApi.status();
      setPlan(res.data.plan);
      setPlanStatus(res.data.plan_status);
      setPlanExpiresAt(res.data.plan_expires_at);
      setInvoicesThisMonth(res.data.invoices_this_month);
      setInvoiceLimit(res.data.invoice_limit);
      setCanCreateInvoice(res.data.can_create_invoice);
    } catch (err) {
      console.error('Failed to fetch subscription status:', err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isAuthenticated) refresh();
  }, [isAuthenticated]);

  return (
    <SubscriptionContext.Provider value={{
      plan, planStatus, planExpiresAt,
      invoicesThisMonth, invoiceLimit, canCreateInvoice,
      loading, refresh, isPro: plan === 'pro',
    }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  return useContext(SubscriptionContext);
}
